import {
  Box,
  SimpleGrid,
  SkeletonCircle,
  SkeletonText,
} from "@chakra-ui/react";

export const ProductSkeletonLoading = () => {
  const CardSkeleton = () => (
    <>
      <Box
        boxShadow="md"
        maxW="sm"
        borderWidth="1px"
        borderRadius="lg"
        overflow="hidden"
        display={"flex"}
        flexDirection="column"
        justifyContent={"center"}
        p={5}
      >
        <SkeletonCircle size="20" mx="auto" />
        <SkeletonText mt="4" noOfLines={4} spacing="4" />
      </Box>
    </>
  );
  return (
    <>
      <SimpleGrid minChildWidth="200px" spacing="40px">
        <CardSkeleton />
        <CardSkeleton />
        <CardSkeleton />
        <CardSkeleton />
        <CardSkeleton />
        <CardSkeleton />
        <CardSkeleton />
        <CardSkeleton />
        <CardSkeleton />
        <CardSkeleton />
        <CardSkeleton />
        <CardSkeleton />
        <CardSkeleton />
        <CardSkeleton />
        <CardSkeleton />
        <CardSkeleton />
      </SimpleGrid>
    </>
  );
};
